import React from 'react';
import { Modal } from 'tea-component';

import DefineField from '@/pages/datalab/pages/Multidimensional/DefineField';
import type { IColumnInfo } from '@dbl/core/dataSource';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import type { CustomColumn } from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import type { ITableJoinRelation } from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/interface';

export interface IOpenDefineFieldModalParams {
  item: IColumnInfo;
  customColumns: CustomColumn[];
  dataTables: IGetTableInfoDto[];
  dataTableJoinRelations: ITableJoinRelation[];
  multiFormatMessage: (key: string) => string;
  commonFormatMessage: (key: string) => string;
  isEn: boolean;
  onConfirm: (customColumn: CustomColumn) => void;
}

/** Sortable 编辑自定义字段：Modal + DefineField，与 PR1 前 index 行为一致 */
export const openDefineFieldModal = (
  params: IOpenDefineFieldModalParams,
): void => {
  const {
    item,
    customColumns,
    dataTables,
    dataTableJoinRelations,
    multiFormatMessage,
    commonFormatMessage,
    isEn,
    onConfirm,
  } = params;

  const modal = Modal.show({
    className: 'add-field dbl-analysis-add-field-model',
    size: 'l',
    caption: multiFormatMessage('edit_field'),
    children: (
      <DefineField
        fieldValue={{
          ...item,
          name_cn: item.column_display,
          name_en: item.column_display,
        }}
        customColumns={customColumns}
        dataTables={dataTables}
        dataTableJoinRelations={dataTableJoinRelations}
        onConfirm={(customColumn: CustomColumn) => {
          onConfirm(customColumn);
          modal.destroy();
        }}
        onClose={() => modal.destroy()}
        multiFormatMessage={multiFormatMessage}
        commonFormatMessage={commonFormatMessage}
        isEn={isEn}
      />
    ),
    onClose: () => modal.destroy(),
  });
};

export interface IConfirmClearAllParams {
  multiFormatMessage: (key: string) => string;
  commonFormatMessage: (key: string) => string;
}

/** 清空筛选确认弹窗，返回用户是否确认 */
export const confirmClearAll = (
  params: IConfirmClearAllParams,
): Promise<boolean> => {
  const { multiFormatMessage, commonFormatMessage } = params;

  return Promise.resolve(
    Modal.confirm({
      className: 'model-delect',
      message: (
        <div className="model-delect-title">
          {multiFormatMessage('clear_message')}
        </div>
      ),
      description: (
        <div className="model-delect-text">
          {multiFormatMessage('clear_des')}
        </div>
      ),
      okText: commonFormatMessage('confirm'),
      cancelText: commonFormatMessage('cancel'),
    }),
  ).then(result => Boolean(result));
};
